@if (!isMobile) {
  <div class="section-top-header ui-mobile-AirDisc">{{ 'common.airDisc_value_calculator_title' | cxTranslate }}</div>
}
@if (isMobile) {
  <div class="section-top-header ui-mobile-AirDisc"  (click)="iconToggler =! iconToggler">{{ 'common.airDisc_value_calculator_title' | cxTranslate }}</div>
}
@if (isMobile?!iconToggler:true) {
  <ul class="my-account-nav mobile-account-nav" >
    <li class="parentLI">
      <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'visitorInfo'?'active':''" href="#visitorInfo" (click)="SelectedComponent('visitorInfo',$event)">{{ 'common.airDisc_value_calculator_visitor_info_title' | cxTranslate }}
        @if (currentComponent === 'visitorInfo') {
          <img src="/icons/link-right-blue.svg" class="right-arrow">
        }</a>
      </li>
      <li class="parentLI">
        <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'fleetInfo'?'active':''" href="#fleetInfo" (click)="SelectedComponent('fleetInfo',$event)">{{ 'common.airdisc_value_calculator_flit_info_title' | cxTranslate }}
          @if (currentComponent === 'fleetInfo') {
            <img src="/icons/link-right-blue.svg" class="right-arrow">
          }</a>
        </li>
        <li class="parentLI">
          <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'fleetSafety'?'active':''" href="#fleetSafety" (click)="SelectedComponent('fleetSafety',$event)">{{ 'common.value_calculator_fleet_safety_title' | cxTranslate }}
            @if (currentComponent === 'fleetSafety') {
              <img src="/icons/link-right-blue.svg" class="right-arrow">
            }</a>
          </li>
          <li class="parentLI">
            <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'frictionMaintainance'?'active':''" href="#frictionMaintainance" (click)="SelectedComponent('frictionMaintainance',$event)">{{ 'common.airdisc_value_calculator_fleet_drumBrake_title' | cxTranslate }}
              @if (currentComponent === 'frictionMaintainance') {
                <img src="/icons/link-right-blue.svg" class="right-arrow">
              }</a>
            </li>
            <li class="parentLI">
              <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'drumBreakCosts'?'active':''" href="#drumBreakCosts" (click)="SelectedComponent('drumBreakCosts',$event)">{{ 'common.airdiscBrake_calculator_drum_costs' | cxTranslate }}
                @if (currentComponent === 'drumBreakCosts') {
                  <img src="/icons/link-right-blue.svg" class="right-arrow">
                }</a>
              </li>
              <li class="parentLI">
                <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'csaViolationCosts'?'active':''" href="#csaViolationCosts" (click)="SelectedComponent('csaViolationCosts',$event)">{{ 'common.airdiscBrake_calculator_csa_costs' | cxTranslate }}
                  @if (currentComponent === 'csaViolationCosts') {
                    <img src="/icons/link-right-blue.svg" class="right-arrow">
                  }</a>
                </li>
                <li class="parentLI">
                  <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'rustMaintainance'?'active':''" href="#rustMaintainance" (click)="SelectedComponent('rustMaintainance',$event)">{{ 'common.airdiscBrake_calculator_rust' | cxTranslate }}
                    @if (currentComponent === 'rustMaintainance') {
                      <img src="/icons/link-right-blue.svg" class="right-arrow">
                    }</a>
                  </li>
                  <li class="parentLI">
                    <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'costSummary'?'active':''" href="#costSummary" (click)="SelectedComponent('costSummary',$event)">{{ 'common.airdiscBrake_calculator_adbCost' | cxTranslate }}
                      @if (currentComponent === 'costSummary') {
                        <img src="/icons/link-right-blue.svg" class="right-arrow">
                      }</a>
                    </li>
                    <li class="parentLI">
                      <a class="my-account-nav-item-link"  [ngClass]="currentComponent === 'drumAdbSummary'?'active':''" href="#drumAdbSummary" (click)="SelectedComponent('drumAdbSummary',$event)">{{ 'common.airDiscBrake_value_calculator_header' | cxTranslate }}
                        @if (currentComponent === 'drumAdbSummary') {
                          <img src="/icons/link-right-blue.svg" class="right-arrow">
                        }</a>
                      </li>
                    </ul>
                  }
